// «Печатает» без «закончил» (закрыли вкладку, пропала сеть) снимаем сами
// через 6 с — как во Flutter (TypingPresence.expireAfter).
const EXPIRE_AFTER = 6000;

const timers = {};

// key — место и пользователь, например `${task_id}/${user_id}`
export function expireTyping(key, onExpire) {
  clearTimeout(timers[key]);
  timers[key] = setTimeout(() => {
    delete timers[key];
    onExpire();
  }, EXPIRE_AFTER);
}

export function cancelTypingExpiry(key) {
  clearTimeout(timers[key]);
  delete timers[key];
}
